/** Name of the Yjs document of a Super note (one document per note) */
export const CollaborationDocumentId = 'super-note';
/**
 * Address of the collaboration relay (standardnotes-collab-relay), e.g. wss://collab.radmit.pl.
 * Added to index.html as <meta name="sn-collab-relay-url"> by the Docker image (docker/40-collab-relay-url.sh);
 * missing or empty means live collaboration is disabled.
 */
export function getCollaborationRelayUrl() {
    var _a;
    const value = (_a = document.querySelector('meta[name="sn-collab-relay-url"]')) === null || _a === void 0 ? void 0 : _a.content.trim();
    return value && /^wss?:\/\//.test(value) ? value.replace(/\/+$/, '') : undefined;
}
export function getSessionAccessToken(application) {
    const session = application.legacyApi.getSession();
    if (!session) {
        return undefined;
    }
    const accessToken = session.accessToken;
    return typeof accessToken === 'string' ? accessToken : accessToken.value;
}
const CursorColors = ['#e5484d', '#0090ff', '#30a46c', '#f76b15', '#8e4ec6', '#d6409f', '#12a594', '#978365'];
/** Stable cursor color of a person, so others recognize them across sessions */
export function getCursorColor(name) {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = (hash * 31 + name.charCodeAt(i)) | 0;
    }
    return CursorColors[Math.abs(hash) % CursorColors.length];
}
